
// MUST be the first import — see sentry-init.ts's doc comment. Arms Sentry
// before any other module in the graph (including firebaseService.ts's
// unguarded initializeApp/getAuth/getFirestore) can throw during evaluation.
import './lib/sentry-init'

// KB-2607: GA4 bootstrap — arms window.gtag before any component mounts.
import './lib/google-analytics-init'

import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
